import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'


interface PlatformState {
  isParamsUpdated: boolean
  isPartnerPlatform: boolean;
  isPlatform: boolean;
  platform: string;
  primaryColor: string | null;
  secondaryColor: string | null;
  isPLJ: boolean | null;
  isfromTDL: boolean;
  isFromBajaj:boolean;
  isFromDsp:boolean;
  isFromPhonePe:boolean;
  isPgCallback: boolean | null;
  shouldRedirect: boolean;
  skipToStep: number | null;
  isFreo: boolean;
  isMarketing: boolean;
  isKYCRedirect: boolean;
  isIframe: boolean;
  isCheckLimitMFC: boolean;
  hideSKDIntroPage: boolean;
  isFromNativeSDK: boolean;
  kyc_response: any | null;
  digio_autopay_response: any | null;
  digio_agreement_response: any | null;
  tataMandateCallback: any | null;
  takeToFlexiPay: boolean;
  isCgtc: boolean;
  user : string,
  customLogoUrl: string;
  customSupportNumber: string | null;
  showDashboardBenefitsForYou: boolean;
  showHome: boolean;
  showInterestCalculator: boolean;
  showLogout: boolean;
  showMyAccountIcon: boolean;
  showPostLoanJourney: boolean;
  showPoweredByVoltMoney: boolean;
  showVoltBottomNavBar: boolean;
  showVoltDefaultHeader: boolean;
  showVoltLogo: boolean;
  showAccountDetails: boolean;
  showLoanClosure: boolean;
  showManageLimit: boolean;
  showTransactionHistory: boolean;
  callData: any | null;
  emailData: string;
  showCall: boolean;
  showEmail: boolean;
  showSupportNumberForPartner: boolean;
  showWA: boolean;
  waData: string;
  partnerReferralCode?: string; // Optional property for partner referral code
  isMfdShareLink?: string; // Flag to indicate if it's an MFD share link
  partnerAccountId?: string; // Optional property for partner account ID
  // Add the index signature for dynamic properties
  [key: string]: any;  // This allows any new key with any value to be added
}



// Define the initial state using that type
const initialState : PlatformState = {
    isParamsUpdated:false,
    isPartnerPlatform:false,
    isPlatform:false,
    platform:'',
    primaryColor:null,
    secondaryColor:null,
    isPLJ:false,
    isfromTDL:false,
    isFromBajaj:false,
    isFromDsp:false,
    isFromPhonePe:false,
    isPgCallback:null,
    shouldRedirect:false, //assuming boolean
    skipToStep:null,
    isFreo:false,
    isMarketing:false,
    isKYCRedirect:false,
    isIframe:false,
    isCheckLimitMFC:false,
    hideSKDIntroPage:false,
    isFromNativeSDK:false,
    kyc_response:null,
    digio_autopay_response:null,
    digio_agreement_response:null,
    tataMandateCallback:null,
    takeToFlexiPay:false,
    isCgtc:false,
    user : '',
    
    customLogoUrl: 'https://volt-images.s3.ap-south-1.amazonaws.com/volt-website-header.svg',
    customSupportNumber:null,
    showDashboardBenefitsForYou:true,
    showHome:true,
    showInterestCalculator:true,
    showLogout:true,
    showMyAccountIcon:true,
    showPostLoanJourney:true,
    showPoweredByVoltMoney:true,
    showVoltBottomNavBar:true,
    showVoltDefaultHeader:true,
    showVoltLogo:true,
    showAccountDetails:true,
    showLoanClosure:true,
    showManageLimit:true,
    showTransactionHistory:true,
    callData:'',
    emailData:'support@voltmoney.in',
    showCall:false,
    showEmail:true,
    showSupportNumberForPartner:true,
    showWA:true,
    waData:'',
    partnerReferralCode: '',
    isMfdShareLink: '',
    partnerAccountId:''
}

export const errorSlice = createSlice({
  name: 'platforParams',
  initialState,
  reducers: {
    updatePartnerParams : (state , action : PayloadAction <typeof initialState>) => {
      // only update keys which are coming and add new keys and preserve initial state
        return{
        ...state,
        ...action.payload,
        isParamsUpdated:true
      }

    },
    resetPartnerParams : () => {
      return {
        ...initialState,
        isParamsUpdated:false,
      }
    }
  },
})

export const { updatePartnerParams, resetPartnerParams } = errorSlice.actions


export default errorSlice.reducer